import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "fw-bold" }
const _hoisted_3 = { class: "fw-bold" }
const _hoisted_4 = { class: "fw-bold" }
const _hoisted_5 = { class: "fw-bold" }
const _hoisted_6 = { class: "fw-bold" }
const _hoisted_7 = { class: "fw-bold" }
const _hoisted_8 = { class: "fw-bold" }
const _hoisted_9 = {
  class: "fw-bold text-nowrap text-truncate",
  style: {"max-width":"200px"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InnerLoader = _resolveComponent("InnerLoader")!
  const _component_Search = _resolveComponent("Search")!
  const _component_Table = _resolveComponent("Table")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_InnerLoader, { loading: _ctx.loading }, null, 8, ["loading"]),
    _createVNode(_component_Search, {
      filter: false,
      filterPlaceholder: 'message.SELECT',
      inputPlaceholder: "message.ENTER_KEY_TO_SEARCH",
      onSearch: _ctx.searchHandler,
      onReloadListing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.getCustomerPayments(1, true))),
      onExportFile: _ctx.exportFile,
      dateFilter: true,
      hidePdf: true
    }, null, 8, ["filterPlaceholder", "onSearch", "onExportFile"]),
    _createVNode(_component_Table, {
      columns: _ctx.columns,
      rows: _ctx.customerPaymentData,
      pagination: _ctx.pagination,
      padding: 5,
      onHandleCurrentChange: _ctx.handleCurrentChange,
      loading: _ctx.loader
    }, {
      "cell-customer_name": _withCtx(({ row: item }) => [
        _createVNode("div", _hoisted_2, _toDisplayString(item?.order?.customer?.user?.name || 'N/A'), 1)
      ]),
      "cell-country_name": _withCtx(({ row: item }) => [
        _createVNode("div", _hoisted_3, _toDisplayString(item?.order?.country?.name || 'N/A'), 1)
      ]),
      "cell-transaction_date": _withCtx(({ row: item }) => [
        _createVNode("div", _hoisted_4, _toDisplayString(item?.order?.created_at || 'N/A'), 1)
      ]),
      "cell-order_number": _withCtx(({ row: item }) => [
        _createVNode("div", _hoisted_5, _toDisplayString(item?.order?.id || 'N/A'), 1)
      ]),
      "cell-payout_date": _withCtx(({ row: item }) => [
        _createVNode("div", _hoisted_6, _toDisplayString(item?.order?.created_at || 'N/A'), 1)
      ]),
      "cell-payout_amount": _withCtx(({ row: item }) => [
        _createVNode("div", _hoisted_7, _toDisplayString(item?.order?.order_total?.find(total => total.code === 'total')?.value || 'N/A'), 1)
      ]),
      "cell-payment_method": _withCtx(({ row: item }) => [
        _createVNode("div", _hoisted_8, _toDisplayString(JSON.parse(item?.payment_method?.name || '{}')?.[_ctx.system_locale]?.name || 'N/A'), 1)
      ]),
      "cell-vat": _withCtx(({ row: item }) => [
        _createVNode("div", _hoisted_9, _toDisplayString(item?.order?.order_total?.find(total => total.code === 'tax')?.value || 'N/A'), 1)
      ]),
      _: 1
    }, 8, ["columns", "rows", "pagination", "onHandleCurrentChange", "loading"])
  ]))
}